import clsx from 'clsx';
import React from 'react';
import { ButtonLink } from '../../_shared/ButtonLink';
import styles from './CollapseButton.module.scss';
import { IconUp } from './IconUp';

interface Props {
    collapsed: boolean;
    className?: string;
    onClick?: () => void;
}

export const CollapseButton: React.FC<Props> = ({
    collapsed,
    className,
    onClick,
}) => (
    <ButtonLink className={clsx(styles.button, className)} onClick={onClick}>
        {collapsed ? 'Расширенный поиск' : 'Свернуть'}{' '}
        <IconUp flip={collapsed} />
    </ButtonLink>
);
